<!-- <script>

	import {onDestroy, onMount} from 'svelte';


	let loading
	let strict = 0
	let group = 0


	let sourcePathList = [
		"1_resources/cocomong_raw.txt",
		"1_resources/cocomong_novel.txt",
		"1_resources/leia_alex.txt",
	]
	let sourcePath = ""

	onMount(() => {
		loading = document.getElementById('loading');
		document.getElementById('user-input').addEventListener('keypress', function (e) {
			if (e.key === 'Enter') {
				sendMessage();
			}
		});
    });

	function showLoadingView() {
		loading.style.display = 'block';
	}

	function hideLoadingView() {
		loading.style.display = 'none';
	}


	/** 
	 * INIT SETTING
	 */
	function initSettingSummary() {
		showLoadingView()  
		let rawText = document.getElementById('data-input').value;
		fetch('/init-setting', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ 
				rawText: rawText,
				summary: true           
			}),
		})
			.then(response => response.json())
			.then(data => {
				hideLoadingView()
				//buttonInit
				document.getElementById('buttonInitRaw').innerText = "Raw";
				document.getElementById('buttonInitSummary').innerText = "Complete!";
				// document.getElementById('buttonInitSummary').disabled = true;
				alert(data.resultText)
			})
			.catch(error => console.error('init-setting ERROR : ', error));    
		
	}


	function initSettingRaw() {
		showLoadingView()    
		let rawText = document.getElementById('data-input').value;
		fetch('/init-setting', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ 
				rawText: rawText,
				summary: false        
			}),
		})
			.then(response => response.json())
			.then(data => {
				hideLoadingView()
				//buttonInit
				document.getElementById('buttonInitRaw').innerText = "Complete!";
				document.getElementById('buttonInitSummary').innerText = "Summary";
				// document.getElementById('buttonInitRaw').disabled = true;
				alert(data.resultText)
			})
			.catch(error => console.error('init-setting ERROR : ', error));
		
	}


	function applyInput(inputId) {
		const inputField = document.getElementById(inputId);
		const message = inputField.value;
		if (message.trim() !== '') {
			showLoadingView()            
			fetch('/init-setting', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ 
					rawText: message,
					summary: false        
				}),
			})
			.then(response => response.json())
			.then(data => {
				hideLoadingView()                        
				alert(data.resultText)
			})
			.catch(error => console.error('init-setting ERROR : ', error));
			
		}
	}




	/** 
	 * CHAT TEST
	 */
	function sendMessage() {
		const inputField = document.getElementById('user-input');
		const message = inputField.value;
		if (message.trim() !== '') {
			displayMessage('Chewbacca', message, 'user');
			inputField.value = '';
			fetchResponse(message);
		}
	}

	function displayMessage(character, message, sender) {
		const chatWindow = document.getElementById('chat-window');
		const messageContainer = document.createElement('div');
		messageContainer.classList.add('message-container', `${sender}-message`);

		const characterElement = document.createElement('div');
		characterElement.classList.add('character');
		characterElement.textContent = character;

		const messageElement = document.createElement('div');
		messageElement.classList.add('message');
		messageElement.textContent = message;

		messageContainer.appendChild(characterElement);
		messageContainer.appendChild(messageElement);
		chatWindow.appendChild(messageContainer);
		chatWindow.scrollTop = chatWindow.scrollHeight;
	}

	function fetchResponse(userMessage) {
		console.log(` userMessage : ${userMessage}`);
		fetch('/direct-request', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				prompt: userMessage,
				strict: strict,
				group: group
			}),
		})
			.then(response => response.json())
			.then(data => {            
				if ( group == 0 ) {
					// GROUP!!                 
					const jsonResponse = JSON.parse(data.resultText);
					Object.keys(jsonResponse).forEach( ( character, index ) => {
						const message = jsonResponse[character];
						
						setTimeout(() => {
							displayMessage(character, message, 'bot');
						}, index * 300); // 0.3초 간격으로 메시지 표시
						
					});
				} else {
					displayMessage("Groovy", data.resultText, 'bot');
					// displayMessage(data.resultText, 'bot');
				}            
			})
			.catch(error => {
				console.error('Error:', error);
				displayMessage('Sorry, something went wrong.', 'bot');
			});
	}


	function toggleGroupButton(type) {
		var buttons = document.getElementsByClassName('toggleGroup'); // 모든 토글 버튼 가져오기    

		Array.from(buttons).forEach((button, index) => {
			if (index === type) {
				button.classList.add('active'); // 클릭된 버튼은 활성화 클래스 추가
				group = index
			} else {
				button.classList.remove('active'); // 다른 버튼들은 활성화 클래스 제거            
			}
		})

	}


	function toggleStrictButton( type ) {    
		var buttons = document.getElementsByClassName('toggleStrict'); // 모든 토글 버튼 가져오기    
		
		Array.from(buttons).forEach((button, index) => {        
			if ( index === type) {        
				button.classList.add('active'); // 클릭된 버튼은 활성화 클래스 추가
				strict = index            
			} else {
				button.classList.remove('active'); // 다른 버튼들은 활성화 클래스 제거
			}      
		})

	}


	function toggleSourceButton( index ) {
		var buttons = document.getElementsByClassName('toggleSource'); // 모든 토글 버튼 가져오기    
		// console.log('selected source : ', index)
		Array.from(buttons).forEach((button, _index) => {        
			if ( _index === index ) {        
				// console.log('index : ', index)
				// console.log('_index : ', _index)
				button.classList.add('active'); // 클릭된 버튼은 활성화 클래스 추가           

				sourcePath = sourcePathList[index] 

				fetch('/get-text', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						sourcePath: sourcePath,                    
					}),
				})
					.then(response => response.json())
					.then(data => {            
						let text = data.resultText
						document.getElementById('data-input').value = text 
					})
					.catch(error => {
						console.error('Error:', error);
						displayMessage('Sorry, something went wrong.', 'bot');
					});
				


			} else {
				button.classList.remove('active'); // 다른 버튼들은 활성화 클래스 제거
			}        
		})
	}


	/** 
	 * IMAGE TEST
	 */
	function generateImage() {
		// showLoadingView()  
		let prompt = document.getElementById('prompt').value;
		fetch('/generate-image', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ prompt: prompt }),
		})
			.then(response => response.json())
			.then(data => {
				// hideLoadingView()
				document.getElementById('generatedImage').src = data.images;            
			})
			.catch(error => console.error('Error generating image:', error));
	}


	async function describeImage() {

		showLoadingView()

		const imageUrl = document.getElementById('imageURL').value;
		fetch('/describe-image', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ imageUrl: imageUrl }),
		})
			.then(response => response.json())
			.then(data => {
				const descriptionContainer = document.getElementById('descriptionContainer');
				descriptionContainer.innerText = `Generated Description : ${data.desc}`;
				hideLoadingView()
				var suffix = "Create a background image that matches the describe next. Never let a person or character be included in the image. "
				var buttons = document.querySelectorAll('.toggle-btn'); // 모든 토글 버튼 가져오기
				buttons.forEach( (button, index) => {
					if ( button.classList.contains('active') ) {
						if ( index == 0 ) {
							suffix += "like a refined graphics style, "
						} else if ( index == 1 ) {
							suffix += "like a hand drawing style, "
						} else if ( index == 2 ) {
							suffix += "and low saturation, soft and subtle, "
						}
					}
				})

				// 배경 테스트 
				// suffix += "Create a background image that matches the describe next. Never make a person or a character."

				const prompt = `${suffix}\n description :\n${data.desc}`;

				showLoadingView()

				fetch('/generate-image', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ prompt: prompt }),
				})
					.then(response => response.json())
					.then(data => {
						hideLoadingView()
						document.getElementById('generatedImage').src = data.images;
					})
					.catch(error => console.error('Error generating image:', error));



				// document.getElementById('desc').src = data.desc;
			})
			.catch(error => console.error('Error describe image:', error));
	}


	function toggleButton(index) {
		var buttons = document.querySelectorAll('.toggle-btn'); // 모든 토글 버튼 가져오기
		buttons.forEach(function(button, i) {      
			if (i === index) {        
				button.classList.add('active'); // 클릭된 버튼은 활성화 클래스 추가
			} else {
				button.classList.remove('active'); // 다른 버튼들은 활성화 클래스 제거
			}
		});  


	}
</script>
<div class="container">                  
        <h2>아바톡 AI챗 테스트 버전</h2>                
        <div class="input-container">            
            <div class="textarea-container">
                <textarea type="text" id="data-input" class="data-input" placeholder="캐릭터 설정을 입력해 주세요."></textarea>
                <button class="apply-button" on:click={applyInput('data-input')}>적용</button>
            </div>            
            <div class="spacerVertical"></div>
            <div class="chat-container">            
                <div class="chat-header">
                    <h2>CHAT TEST</h2>
                </div>
                <div class="chat-window" id="chat-window">                    
                </div>            
                <div class="chat-input">
                    <input type="text" id="user-input" placeholder="메시지를 입력 해 주세요.">
                    <button on:click={sendMessage()}>Send</button>
                </div>
            </div>
        </div>                        
        <div class="horizontal-container">
            <div>샘플 데이터 :: </div>
            <button class="toggleSource" on:click={toggleSourceButton(0)}>cocomong_origin</button>
            <button class="toggleSource" on:click={toggleSourceButton(1)}>cocomong_novel</button>
            <button class="toggleSource" on:click={toggleSourceButton(2)}>leia & alex</button>
        </div>
        <div class="horizontal-container">
            <div>내용이 많을 경우, 요약할 수 있습니다 :: </div>
            <button id="buttonInitSummary" on:click={initSettingSummary}>Summary</button>
            <button id="buttonInitRaw" on:click="initSettingRaw()">원본</button>
        </div>        
        <div class="horizontal-container">
            <div>데이터를 참조하는 의존도를 설정할 수 있습니다 :: </div>
            <button class="toggleStrict" on:click={toggleStrictButton(0)}>Less strict</button>
            <button class="toggleStrict" on:click={toggleStrictButton(1)}>More strict</button>            
        </div>
        <div class="horizontal-container">
            <div>Group chat :: </div>
            <button class="toggleGroup" on:click={toggleGroupButton(0)}>YES</button>
            <button class="toggleGroup active" on:click={toggleGroupButton(1)}>NO</button>
        </div>
        <div class="spacer"></div>
        <h2>Image URL</h2>
        <input type="text" id="imageURL" placeholder="url 를 입력하세요!">
        <button class="toggle-btn active" on:click={toggleButton(0)}>그래픽</button>
        <button class="toggle-btn" on:click={toggleButton(1)}>일러스트</button>
        <button class="toggle-btn" on:click={toggleButton(2)}>부드러운</button>
        <button id="describeImage" on:click={describeImage()}>Describe and Generate Image</button>
        <div id="descriptionContainer"></div>
        <h2>Prompt</h2>
        <input type="text" id="prompt" placeholder="prompt 를 입력하세요!">
        <button on:click={generateImage()}>Generate Image</button>
        <img id="generatedImage" src="" alt="Generated Image" style="max-width: 100%;">
        <div class="loading" id="loading">
            <div class="spinner"></div>
            <p>Loading...</p>
        </div>
        <div class="spacer"></div>        
        <hr class="styled-hr">
        <div class="spacer"></div>        
        
    </div>   
	
<style>
	.container {
		font-family: Arial, sans-serif;
		background-color: #f4f4f4;
		color: #333;
		text-align: center;
		padding: 20px;
	}


	.input-container {
		width: 820px;
		height: 75vh;
		max-height: 80vh;
		display: flex;
		flex-direction: row; /* 가로 배열 */
		align-items: flex-start;    
		max-width: 1000px;
	}

	.textarea-container {
		position: relative;    
		width: 400px;    
		height: 100%;
		max-height: 100%;    
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
		border-radius: 8px;     
	}

	.data-input {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 5px;
		font-size: 16px;
		resize: none;
		overflow-y: auto;
		height: 100%;
		box-sizing: border-box;
	}

	.apply-button {
		position: absolute;
		right: 10px;
		bottom: 10px;
		padding: 5px 10px;
		background-color: #4caf50;
		color: #fff;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		font-size: 14px;
	}

	.apply-button:hover {
		background-color: #45a049;
	}

	/**
	* CHAT!!
	*/
	/* styles.css */
	.chat-container {
		width: 400px;
		height: 100%;
		max-width: 100%;    
		max-height: 100%;    
		background-color: #fff;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.chat-header {
		background-color: grey;
		padding: 10px;
		color: #fff;
		text-align: center;
		flex-shrink: 0;
	}

	.chat-window {
		flex: 1;
		padding: 15px;
		overflow-y: auto;
		/* 오버플로우될 경우 스크롤바 표시 */
		display: flex;
		flex-direction: column;
	}

	.chat-input {
		display: flex;
		border-top: 1px solid #ddd;
		flex-shrink: 0;    
	}

	.chat-input input {
		flex: 1;
		padding: 10px;
		border: none;
		border-right: 1px solid #ddd;
		font-size: 16px;
	}

	.chat-input button {
		padding: 10px;
		background-color: #4caf50;
		color: #fff;
		border: none;
		cursor: pointer;
		font-size: 16px;
	}

	.chat-input button:hover {
		background-color: #45a049;
	}

	.message-container {
		margin: 10px 0;
		display: flex;
		flex-direction: column;
		max-width: 80%;
		word-wrap: break-word;
	}

	.user-message {
		align-self: flex-end;
		text-align: right;
	}

	.bot-message {
		align-self: flex-start;
		text-align: left;
	}

	.character {
		font-weight: bold;
		margin-bottom: 5px;
	}

	.message {
		padding: 10px;
		border-radius: 5px;
	}

	.user-message .message {
		background-color: #e1ffc7;
	}

	.bot-message .message {
		background-color: #f1f1f1;
	}
	/**
	* CHAT!!
	*/

	.spacerVertical {
		width: 20px; /* 두 div 사이의 간격을 설정 */
	}

	.spacer {
		height: 100px; /* 두 div 사이의 간격을 설정 */
	}
		
	.styled-hr {
		border: 0;
		height: 2px;
		background: linear-gradient(to right, #f00, #00f);
		margin: 20px 0;
	}
	
	.horizontal-container {
		display: flex;
		justify-content: center; /* 필요에 따라 flex-start, center, space-between 등을 사용 */
		gap: 20px; /* 버튼들 사이에 20px 간격을 설정 */
	}


	.container {
		display: flex;
		flex-direction: column;
		/* 자식 요소들을 세로로 배열하도록 설정 */
		align-items: center;
		/* 자식 요소들을 수평으로 가운데 정렬 */
	}

	.container>* {
		margin: 10px 0;
		/* 위아래로 10px의 여백을 주어 세로 간격을 조절 */
	}

	input[type="text"] {
		width: 300px;
		text-align: center;
	}

	input[type="text"]::placeholder {
		text-align: center;
	}

	#responseContainer {
		width: 50%;
	}

	#describeImage {
		height: 48px;
	}

	.toggleSource{
		display: inline-block;
		background-color: #ccc;
		color: #333;
		height: 24px;
		line-height: 24px;
		/* padding: 8px; */
		border: none;
		border-radius: 5px;
		cursor: pointer;
		transition: background-color 0.3s ease;      
		font-size: 9pt;
	}

	.toggleSource.active {
		background-color: #007bff;
		color: #fff;  
	}

	.toggleStrict {
		display: inline-block;
		background-color: #ccc;
		color: #333;
		height: 24px;
		line-height: 24px;
		/* padding: 8px; */
		border: none;
		border-radius: 5px;
		cursor: pointer;
		transition: background-color 0.3s ease;      
		font-size: 9pt;
	}

	.toggleStrict.active {
		background-color: #007bff;
		color: #fff;  
	}


	.toggleGroup {
		display: inline-block;
		background-color: #ccc;
		color: #333;
		height: 24px;
		line-height: 24px;
		/* padding: 8px; */
		border: none;
		border-radius: 5px;
		cursor: pointer;
		transition: background-color 0.3s ease;
		font-size: 9pt;
	}

	.toggleGroup.active {
		background-color: #007bff;
		color: #fff;
	}



	.toggle-btn {    
		display: inline-block;
		background-color: #ccc;
		color: #333;
		height: 24px;
		line-height: 24px;
		/* padding: 8px; */
		border: none;
		border-radius: 5px;
		cursor: pointer;
		transition: background-color 0.3s ease;      
		font-size: 9pt;
	}
		
	.toggle-btn:hover {
		background-color: #bbb;
	}

	/* 첫 번째 버튼은 초기에 선택되어 있는 상태로 스타일 변경 */
	.toggle-btn.active {
		background-color: #007bff;
		color: #fff;  
	}
		

	.loading {
		display: none;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: rgba(255, 255, 255, 0.8);
		padding: 20px;
		border-radius: 10px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
	}

	.loading .spinner {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		border: 4px solid #ccc;
		border-top-color: #333;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
</style>
--> 
<iframe src="https://ec2-52-78-243-23.ap-northeast-2.compute.amazonaws.com" />
<style>
	iframe {
		width: -webkit-fill-available;
    	height: -webkit-fill-available;	
	}
</style>